import { render, staticRenderFns } from "./pos-checkout.vue?vue&type=template&id=5814048e&scoped=true&"
import script from "./pos-checkout.ts?vue&type=script&lang=ts&"
export * from "./pos-checkout.ts?vue&type=script&lang=ts&"
import style0 from "./pos-checkout.scss?vue&type=style&index=0&id=5814048e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5814048e",
  null
  
)

export default component.exports